import { gql } from '@apollo/client';

export const WORKPLACE_CASE_TYPES_DOCTOR = gql`
    query WorkplaceCaseTypesDoctor($workplaceId: UUID, $caseTypeTypes: [CaseTypeType]) {
        workplaceCaseTypesDoctor(
            workplaceId: $workplaceId
            caseTypeTypes: $caseTypeTypes
            pagination: {
                take: 9999
            }
        ) {
            data {
                id
                caseType {
                    label
                    type
                    eventInterval
                }
            }
        }
    }
`;
